import { useEffect } from 'react';
export var useClassOnScroll = function useClassOnScroll(elementRef, className) {
  useEffect(function () {
    var handleScroll = function handleScroll() {
      if (window.scrollY > 1) {
        var _elementRef$current;
        elementRef === null || elementRef === void 0 ? void 0 : (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.classList.add(className);
      } else {
        var _elementRef$current2;
        elementRef === null || elementRef === void 0 ? void 0 : (_elementRef$current2 = elementRef.current) === null || _elementRef$current2 === void 0 ? void 0 : _elementRef$current2.classList.remove(className);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [className, elementRef]);
};